import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { appSchool, startNativeShell } from '@/lib/native';

/** The school's logo and name at the top of the sign-in screens, shown only in that school's own app. */
export function AppSchoolHeader({ subtitle }: { subtitle?: string }) {
  if (!appSchool) return null;
  return (
    <div className="flex flex-col items-center text-center mb-8 md:hidden">
      <img src={appSchool.logo} alt="" className="w-20 h-20 rounded-2xl object-contain bg-white shadow-sm ring-1 ring-slate-200 p-1.5" />
      <p className="mt-3 text-lg font-extrabold text-[#0A2540] leading-tight">{appSchool.name}</p>
      {subtitle && <p className="text-xs text-slate-500 mt-0.5">{subtitle}</p>}
    </div>
  );
}

/** Mount once inside the router: Android back button, status bar and splash screen (does nothing on the website). */
export function NativeShell() {
  const nav = useNavigate();
  useEffect(() => {
    void startNativeShell(() => {
      const idx = (window.history.state as { idx?: number } | null)?.idx ?? 0;
      if (idx > 0) { nav(-1); return true; }
      return false;
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return null;
}
